export default () => ({
  isOpen: false,

  toggle() {
    this.isOpen = !this.isOpen;
  },
});
